import { createAction } from '@reduxjs/toolkit';
export const MERGE_CALL_SESSIONS = 'MERGE_CALL_SESSIONS';
export const mergeCallSessionsAction = createAction(MERGE_CALL_SESSIONS);